export var MPAOperationType;
(function (MPAOperationType) {
    MPAOperationType["MPA_OPERATION_TYPE_MPA_OPERATION_ADD_RESTORE_ACCOUNT"] = "MPA_OPERATION_ADD_RESTORE_ACCOUNT";
    MPAOperationType["MPA_OPERATION_TYPE_MPA_OPERATION_RESTORE_RESOURCE"] = "MPA_OPERATION_RESTORE_RESOURCE";
    MPAOperationType["MPA_OPERATION_TYPE_MPA_OPERATION_UPDATE_BACKUP_POLICY"] = "MPA_OPERATION_UPDATE_BACKUP_POLICY";
    MPAOperationType["MPA_OPERATION_TYPE_MPA_OPERATION_DELETE_BACKUP_POLICY"] = "MPA_OPERATION_DELETE_BACKUP_POLICY";
    MPAOperationType["MPA_OPERATION_TYPE_MPA_OPERATION_REMOVE_SNAPSHOT_HOLD"] = "MPA_OPERATION_REMOVE_SNAPSHOT_HOLD";
})(MPAOperationType || (MPAOperationType = {}));
